"use client";
import React, { useState, ReactNode } from "react";
import classnames from "classnames";
import { FmDrawer, FmIcon, IIconProps } from "@/ui-component";
import stl from "./linkWithUP.module.scss";
interface IProps extends Omit<IIconProps, "icon"> {
    children: ReactNode;
    classes?: Partial<{
        icon: string;
    }>;
}
const CYLHelp: React.FC<IProps> = (props) => {
    const [show, setShow] = useState(false);
    return (
        <React.Fragment>
            <FmIcon
                icon={"icon--FAQ"}
                className={classnames(
                    stl["q-mark"],
                    stl["h5-special-q-mark"],
                    props.classes?.icon,
                )}
                onClick={() => setShow(true)}
            />
            {/* <QMark clas={"h5-special-q-mark"} click={() => setShow(true)} /> */}
            <FmDrawer
                closeable
                onClose={() => setShow(false)}
                open={show}
                anchor="bottom"
                closeablePosition="right"
                childrenClassName={stl["drawer-children"]}
                headerChildren
            >
                {props.children}
            </FmDrawer>
        </React.Fragment>
    );
};
export default CYLHelp;
